import "./UpArrow.scss"

const UpArrow = () => {
  return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
      className="upArrow--svg"
		>
			<path d="M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12-5.373-12-12-12-12 5.373-12 12zm17-1h-4v8h-2v-8h-4l5-6 5 6z" />
		</svg>
	);
}

export default UpArrow
